import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import {
  fetchPageBlockItemsList,
  applyPageBlockItemsDrag,
  clearPageBlockItemsDrag,
} from 'redux/users/actions';

import {
  DragDropContext,
  Droppable,
  Draggable,
} from "react-beautiful-dnd";

import './PlacementManager.css';

class PlacementManager extends Component {
    static propTypes = {
    fetchPageBlockItemsList: PropTypes.func.isRequired,
    applyPageBlockItemsDrag: PropTypes.func.isRequired,
    clearPageBlockItemsDrag: PropTypes.func.isRequired,
    pageBlockItemsList: PropTypes.arrayOf(PropTypes.shape),
  };

  static defaultProps = {
    pageBlockItemsList: null,
  };

  state = {
    items: null,
  };

  componentDidMount() {
    this.props.fetchPageBlockItemsList();
    this.setState({ items: this.props.pageBlockItemsList });
  }

  componentDidUpdate(prevProps) {
    // Set Current List
    if (prevProps.pageBlockItemsList !== this.props.pageBlockItemsList) {
      this.setState({ items: this.props.pageBlockItemsList });
    }

    // Drag and Drop
    if (
      !prevProps.pageBlockItemsDragSuccess &&
      prevProps.pageBlockItemsDragSuccess !== this.props.pageBlockItemsDragSuccess
    ) {
      this.props.fetchPageBlockItemsList();
      this.props.clearPageBlockItemsDrag();
    }
  }

  componentWillUnmount() {
    if (this.props.pageBlockItemsDragSuccess) {
      this.props.clearPageBlockItemsDrag();
    }
  }

  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  onDragEnd = result => {
    if (!result.destination) {
      return;
    }

    const items = this.reorder(
      this.state.items,
      result.source.index,
      result.destination.index
    );

    this.setState({ items }, () => {
      const form = new FormData();
      this.state.items.map(item => item.id)
        .forEach(item => form.append('order', item));
      this.props.applyPageBlockItemsDrag(form);
    });
  };

  renderBlockItemsList = () => {
    const { items } = this.state;

    const mapping = [
      {
        initial: 'links',
        text: 'Links',
      },
      {
        initial: 'crypto',
        text: 'Crypto Links',
      },
      {
        initial: 'sliders',
        text: 'Sliders',
      },
      {
        initial: 'music',
        text: 'Music Links',
      },
      {
        initial: 'apps',
        text: 'Apps',
      },
      {
        initial: 'social',
        text: 'Social Links',
      },
      {
        initial: 'signups',
        text: 'Signups',
      },
      {
        initial: 'messages',
        text: 'Messages',
      },
      {
        initial: 'commerce',
        text: 'Commerce',
      },
      {
        initial: 'maps',
        text: 'Locations & Maps',
      },
      {
        initial: 'menu',
        text: 'Menu',
      },
    ];
    
    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="droppable">
          {provided => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {items && items.map((item, index) => (
                <Draggable
                  key={`${item.id}`}
                  draggableId={`${item.id}`}
                  index={index}
                >
                  {provided => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <div className={`block-item${!item.is_active ? ' inactive': ''}`}>
                        <div className={`icon ${item.block_type}`} />
                        <div className="text">
                          {mapping.filter(mapItem => mapItem.initial === item.block_type)[0] &&
                            mapping.filter(mapItem => mapItem.initial === item.block_type)[0].text}
                        </div>
                        <div className="move-icon" />
                      </div>
                    </div>
                  )}
                </Draggable>
              ))}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  };

  render() {
    const { items } = this.state;

    return (
      <div className="placement-manager__component">
        {/* Block Items List */}
        {items && items.length > 0 &&
          this.renderBlockItemsList()
        }
      </div>
    );
  }
}

const mapStateToProps = state => (
  {
    pageBlockItemsList: state.usersReducer.pageBlockItemsList,
    pageBlockItemsDragSuccess: state.usersReducer.pageBlockItemsDragSuccess,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchPageBlockItemsList,
    applyPageBlockItemsDrag,
    clearPageBlockItemsDrag,
  },
)(PlacementManager);
